import { FormattedMessage, useIntl } from 'react-intl';

interface Props {
  showViewToggle: boolean;
  isTableView: boolean;
  onSelectView: (mode: 'table' | 'card') => void;
}

export default function AccountsListHeader({ showViewToggle, isTableView, onSelectView }: Props) {
  const intl = useIntl();

  return (
    <div className="mb-6 flex flex-wrap items-center justify-between gap-3">
      <h1 className="text-2xl font-bold text-gray-800 sm:text-3xl">
        <FormattedMessage id="accounts.list.title" />
      </h1>
      {showViewToggle && (
        <div className="flex items-center rounded-xl border border-slate-200 bg-white/80 p-1 shadow-sm">
          <button
            type="button"
            aria-label={intl.formatMessage({ id: 'accounts.list.viewTable' })}
            aria-pressed={isTableView}
            onClick={() => onSelectView('table')}
            className={[
              'rounded-lg p-2 text-slate-500 transition focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-300',
              isTableView ? 'bg-slate-900 text-white shadow-sm' : 'hover:bg-slate-100 hover:text-slate-700',
            ].join(' ')}
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
              <path d="M2 5a2 2 0 012-2h12a2 2 0 012 2v1H2V5zM2 8h16v7a2 2 0 01-2 2H4a2 2 0 01-2-2V8zm5 2a1 1 0 000 2h2a1 1 0 100-2H7zm0 3a1 1 0 000 2h2a1 1 0 100-2H7zm5-3a1 1 0 100 2h2a1 1 0 100-2h-2zm0 3a1 1 0 100 2h2a1 1 0 100-2h-2z" />
            </svg>
          </button>
          <button
            type="button"
            aria-label={intl.formatMessage({ id: 'accounts.list.viewCards' })}
            aria-pressed={!isTableView}
            onClick={() => onSelectView('card')}
            className={[
              'rounded-lg p-2 text-slate-500 transition focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-300',
              isTableView ? 'hover:bg-slate-100 hover:text-slate-700' : 'bg-slate-900 text-white shadow-sm',
            ].join(' ')}
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
              <path d="M3 3a2 2 0 00-2 2v4a2 2 0 002 2h4a2 2 0 002-2V5a2 2 0 00-2-2H3zm0 10a2 2 0 00-2 2v2a2 2 0 002 2h4a2 2 0 002-2v-2a2 2 0 00-2-2H3zm10-10a2 2 0 00-2 2v4a2 2 0 002 2h4a2 2 0 002-2V5a2 2 0 00-2-2h-4zm0 10a2 2 0 00-2 2v2a2 2 0 002 2h4a2 2 0 002-2v-2a2 2 0 00-2-2h-4z" />
            </svg>
          </button>
        </div>
      )}
    </div>
  );
}
